import { HTTPServer } from '@/common/js/ajax'
import * as types from '../mutations-types'
const state = {
  common_fields: [],
  preview_common_fields: [],
  paltform_template_layout: [],
  preview_template_layout: [],
  custom_appearance_new: {}
}
const getters = {
  common_fields: state => state.common_fields,
  paltform_template_layout: state => state.paltform_template_layout,
  preview_common_fields: state => state.preview_common_fields,
  preview_template_layout: state => state.preview_template_layout,
  custom_appearance_new: state => state.custom_appearance_new
}
const actions = {
  templateFindListFindList: ({ commit, state }, data) => {
    HTTPServer.templateFindListFindList(data, 'Loading').then(res => {
      res.dataList.map((v1, k) => {
        if (v1.type === 'subform') {
          if (!v1.field.add) {
            if (v1.field.fieldControl === '1') {
              v1.field.add = '0'
              v1.field.delete = '0'
              v1.field.mustFill = '0'
            } else if (v1.field.fieldControl === '2') {
              v1.field.add = '1'
              v1.field.delete = '1'
              v1.field.mustFill = '1'
            } else {
              v1.field.add = '1'
              v1.field.delete = '1'
              v1.field.mustFill = '0'
            }
          }
        }
      })
      commit('COMMON_FIELDS', res.dataList)
    })
  }
}
const mutations = {
  [types.COMMON_FIELDS](state, commonFields) {
    state.common_fields = commonFields
  },
  [types.PLATFORM_TEMPLATE_LAYOUT](state, paltformTemplateLayout) {
    state.paltform_template_layout = paltformTemplateLayout
  },
  [types.PREVIEW_COMMON_FIELDS](state, previewCommonFields) {
    state.preview_common_fields = previewCommonFields
  },
  [types.PREVIEW_TEMPLATE_LAYOUT](state, previewTemplateLayout) {
    state.preview_template_layout = previewTemplateLayout
  },
  [types.CUSTOM_APPEARANCE_NEW](state, customAppearanceNew) {
    state.custom_appearance_new = customAppearanceNew
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
